import VIDEO_TYPE from "enums/VIDEO_TYPE";
import TimelineItem from "types/TimelineItem";
import getVideoDownloadFilename from "utils/getVideoDownloadFilename";

export function isDownloadableItem(timelineItem: TimelineItem) {
  return (
    Boolean(timelineItem.signedSourceUrl) &&
    timelineItem.allowDownload !== false &&
    (timelineItem.type === VIDEO_TYPE.VIDEO ||
      timelineItem.type === VIDEO_TYPE.CLIP ||
      timelineItem.type === VIDEO_TYPE.INSIGHT ||
      timelineItem.type === VIDEO_TYPE.IMAGE)
  );
}

export function createDownloadFilename(
  timelineItem: TimelineItem,
  index: number,
) {
  const title =
    timelineItem.videoTitle?.replace(/[^a-zA-Z0-9 ]/g, "").trim() ||
    `video_${index + 1}`;

  return getVideoDownloadFilename(
    {
      title,
      type: timelineItem.type,
      originalFilename: timelineItem.signedSourceUrl,
    },
    undefined,
  );
}
